"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fonts = void 0;

var _webfontloader = _interopRequireDefault(require("webfontloader"));

var _typography = require("@vds-core/typography");

//****** To-do, test loading in the families first asynchronously from check whether to load the url if necessary ******//
var FontConfig = {
  loaded: false
}; //Turn on or off the font loader

function setFontLoaded(loaded) {
  FontConfig.loaded = loaded ? true : false;
  _typography.Fonts.setFontLoaded && _typography.Fonts.setFontLoaded(loaded);
}

function checkFontLoaded() {
  return FontConfig.loaded;
} // Define and Load the fonts


var customConfig = {
  families: ['Verizon-NHG-eTX', 'Verizon-NHG-eDS']
};
var fontUri1 = 'https://respframework.verizon.com/fonts/eText/verizon-nhg-etx-update.css';
var fontUri2 = 'respframework.verizon.com/fonts/eText/verizon-nhg-etx.css';

function finishLoading(customConfig) {
  var WebFontConfig = {
    custom: customConfig,
    active: function active() {
      return setFontLoaded(true);
    },
    inactive: function inactive() {
      return console.warn('fonts could not be loaded.');
    }
  };

  _webfontloader["default"].load(WebFontConfig);
}

function checkIfLoaded() {
  var links = Array.from(document.head.getElementsByTagName('link'));
  if (!links || !links.length) return false;
  return links.find(function (link) {
    return link.getAttribute('href') === fontUri1 || link.getAttribute('href') === fontUri2;
  });
}

function loadFonts() {
  var loaded = checkIfLoaded();

  if (!loaded) {
    customConfig.urls = [fontUri1];
    finishLoading(customConfig);
  } else setFontLoaded(true);
}

if (checkIfLoaded()) setFontLoaded(true);
if (!checkFontLoaded()) loadFonts();
var Fonts = {
  VerizonNHGeDS: 'Verizon-NHG-eDS',
  // Display
  VerizonNHGeTX: 'Verizon-NHG-eTX',
  // Text
  checkFontLoaded: checkFontLoaded,
  setFontLoaded: setFontLoaded,
  loadFonts: loadFonts
};
exports.Fonts = Fonts;